import { render, staticRenderFns } from "./GoodsDelivery.vue?vue&type=template&id=0061229a&scoped=true"
import script from "./GoodsDelivery.vue?vue&type=script&lang=js"
export * from "./GoodsDelivery.vue?vue&type=script&lang=js"
import style0 from "./GoodsDelivery.vue?vue&type=style&index=0&id=0061229a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0061229a",
  null
  
)

export default component.exports